import {useQuery} from 'react-query'

import {graphQLClientSessionManager} from '@/utils/clientGqlSessionManager'

export const useUser = (id: string | null | undefined) =>
  useQuery(['user', id], async () => {
    try {
      if (!id) {
        return null
      }
      // The shell runs this on every page; importing on demand keeps the GraphQL client and all
      // generated documents out of it. The token is fetched meanwhile, and getClientGQL reuses it.
      const [{getClientGQL}] = await Promise.all([
        import('@/utils/clientGql'),
        graphQLClientSessionManager.getToken(),
      ])
      const gqlclient = await getClientGQL()
      return (await gqlclient.userForUserGetById({id}))?.user_by_pk
    } catch (e) {
      throw new Error(e)
    }
  })
